export default __webpack_public_path__ + "static/media/20290527-PMP Certfication.7dc9d82b.jpg";